import { getApi, patchApi, postApi } from "./apiService"

export const getAllSubscriptionPlans = async () => {
    return await getApi("/mp/merchant/admin/subscription-plans")
}

export const getCurrentSubscription = async () => {
    return await getApi("/mp/merchant/subscription/current")
}

export const subscribeToPLan = async (body) => {
    return await postApi("/mp/merchant/subscription/initiate-payment", body)
}
export const confirmPayment = async (body) => {
    return await postApi("/mp/merchant/subscription/confirm-payment", body)
}

export const UpgradetoHigherPlan = async (body) => {
    return await postApi("/mp/merchant/subscription/upgrade", body)
}

export const RenewActiveSubscription = async (body) => {
    return await postApi("/mp/merchant/subscription/renew", body)
}

export const getSubscriptionHistory = async () => {
    return await getApi("/mp/merchant/active/subscription/history")
}